import React from 'react';

function Plus(props) {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M3.4375 11H18.5625" stroke={props.fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11 3.4375V18.5625" stroke={props.fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default Plus;
